import { atom } from 'recoil';

export const userId = atom({
  key: 'userId',
  default: undefined,
});
